export const isBrowser = typeof window !== 'undefined'

export const isIOS = () => {
  if (!isBrowser) return false

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
  )
}
